
import { ActionButton, DefaultButton, DefaultEffects, IButtonStyles, IconButton, PrimaryButton } from '@fluentui/react';
import { Text, ITextProps } from '@fluentui/react/lib/Text';
import React, { useMemo, useRef, useState } from 'react';
import TinderCard from 'react-tinder-card';
import { card } from '../App';
import './Cards.css';

const Cards: React.FC<CardsProps> = (props: CardsProps) => {

    const btnStyles: IButtonStyles = {
        rootHovered: {
            backgroundColor: "rgb(255,95,80)",
            border: 0
        },
        rootPressed: {
            backgroundColor: "#1a1b4a",
            border: 0
        },
        root: {
            fontSize: '18px',
            padding: '20px',
            width: '120px',
            border: 0,
            borderRadius: '10px'
        }
    };

    const results = useRef<card[]>([...props.cards]);

    const [currentIndex, setCurrentIndex] = useState(props.cards.length - 1)
    // const [lastDirection, setLastDirection] = useState<string>()
    // used for outOfFrame closure
    const currentIndexRef = useRef(currentIndex)

    const childRefs = useMemo<any>(
        () =>
            Array(props.cards.length)
                .fill(0)
                .map((i) => React.createRef()),
        []
    );

    const updateCurrentIndex = (val: number) => {
        setCurrentIndex(val)
        currentIndexRef.current = val
    }

    const canGoBack = currentIndex < props.cards.length - 1

    const canSwipe = currentIndex >= 0

    // set last direction and decrease current index
    const swiped = (direction: string, nameToDelete: string, index: number) => {
        // setLastDirection(direction)
        results.current[results.current.findIndex(c => c.name === nameToDelete)].result = (direction === 'right');
        updateCurrentIndex(index - 1)

        if (index === 0) {
            props.finished(results.current);
        }
    }

    const outOfFrame = (name: string, idx: number) => {
        // console.log(`${name} (${idx}) left the screen!`, currentIndexRef.current)
        // handle the case in which go back is pressed before card goes outOfFrame
        currentIndexRef.current >= idx && childRefs[idx].current.restoreCard()


        // TODO: when quickly swipe and restore multiple times the same card,
        // it happens multiple outOfFrame events are queued and the card disappear
        // during latest swipes. Only the last outOfFrame event should be considered valid
    }

    const swipe = async (dir: string) => {
        if (canSwipe && currentIndex < props.cards.length) {
            await childRefs[currentIndex].current.swipe(dir) // Swipe the card!
        }
    }

    // increase current index and show card
    const goBack = async () => {
        if (!canGoBack) return
        const newIndex = currentIndex + 1
        updateCurrentIndex(newIndex)
        await childRefs[newIndex].current.restoreCard()
    }

    return (
        <div style={{ width: '100%', display: 'flex', alignItems: 'center', flexDirection: 'column', justifyContent: 'center' }}>
            <div style={{ height: '460px', width: '100%', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
                {[...props.cards].reverse().map((c, i) => {
                    return (
                        <TinderCard
                            preventSwipe={['up', 'down']}
                            key={c.id}
                            ref={childRefs[i]}
                            onSwipe={(dir) => swiped(dir, c.name, i)}
                            onCardLeftScreen={() => outOfFrame(c.name, i)}
                            className='swipe'
                        >
                            <div className={0 === i ? 'card cardshadow' : 'card'}>
                                <div style={{ textAlign: 'center', padding: '40px', height: '250px' }}>
                                    <img style={{ width: '100%', position: 'relative', top: '50%', transform: 'translateY(-50%)' }} src={c.imageurl} alt={c.name} />
                                </div>
                                <div className='card-text'>
                                    {c.name}
                                </div>
                            </div>
                        </TinderCard>);
                })}
            </div>


            <div style={{ margin: '15px 0 20px 0' }}>
                <Text>
                    Doe je dit voor je naaste?
                </Text>
            </div>

            <div style={{ display: 'flex' }}>
                <PrimaryButton iconProps={{ iconName: 'ErrorBadge' }} disabled={!canSwipe} styles={btnStyles} style={{ margin: '0 10px' }} text='Nee' onClick={() => { swipe('left') }} />
                <div style={{ width: '110px', textAlign: 'center' }}>
                    {canGoBack &&
                        <ActionButton styles={{ root: {} }} iconProps={{ iconName: 'Undo' }} disabled={!canGoBack} text='Stap terug' onClick={() => { goBack() }} />
                    }
                </div>
                <PrimaryButton iconProps={{ iconName: 'CheckMark' }} disabled={!canSwipe} styles={btnStyles} style={{ margin: '0 10px' }} text='Ja' onClick={() => { swipe('right') }} />
            </div>
        </div>)
}

interface CardsProps {
    cards: any[]
    finished: (results: card[]) => void;
}

export default Cards